import React, { useState } from "react";
import "../../../assets/scss/account/register.scss";
import "../../../assets/scss/account/forgotPassword.scss";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import HeaderLogo from "../../../components/header/headerLogo";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import Repository from "../../../configs/axios/repository";
import marketingJpg from "../../../assets/images/account/login.svg";
import view from "../../../assets/images/account/veiw.png";
import hidenIcon from "../../../assets/images/account/hideIcon.png";
import { useHistory } from "react-router-dom";

const ForgotPassword = (props) => {
    const history = useHistory();
    const myArray = props.location.pathname.split("/resetPassword/");
    const verifyCode = myArray[1];
    const [loadingData, setLoadingData] = useState(true);
    const [showPasword, setShowPasword] = useState(false);
    const [password, setPassword] = useState("");
    const [showConfirmPasword, setShowConfirmPasword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");

    const resetPassword = async (values) => {
        setLoadingData(false);
        let data = {
            password: values.password,
            verification_code: Number(verifyCode),
        };
        const result = await Repository.updateData(
            `api/users/resetPassword`,
            data
        );
        setLoadingData(true);
        if (result.data?.success === true) {
            //

            Swal.fire({
                text: "Your password has been successfully changed․",
                icon: "success",
                confirmButtonColor: "#16285e",
            }).then((result) => {
                if (result.isConfirmed) {
                    history.push("/");
                }
            });
        } else {
            Swal.fire({
                text: "Your verification code has changed. Please send a new forgotten password request to send a new verification code to the mail.",
                icon: "warning",
                confirmButtonColor: "red",
            });
        }
    };

    return loadingData ? (
        <div>
            <HeaderLogo />
            <div className="sectionParentDiv">
                <div className="registerContent ">
                    <div>
                        <div className="rounded mx-auto d-block forgootField">
                            <h1>Forgot Password</h1>
                            <p>
                                We will send you a link to this email to reset
                                your password.
                            </p>
                            <Formik
                                initialValues={{
                                    password: "",
                                    confirmPassword: "",
                                }}
                                validate={(values) => {
                                    const errors = {};
                                    const specialSymbols =
                                        /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
                                    const letters = /[a-zA-Z]/;

                                    if (values.password) {
                                        setPassword(values.password);
                                    }

                                    if (!values.password) {
                                        setPassword(values.password);
                                        errors.password =
                                            "Password is required.";
                                    } else if (values.password.length < 6) {
                                        errors.password =
                                            "Password must consist of 6 members";
                                    } else if (
                                        !specialSymbols.test(values.password) ||
                                        !letters.test(values.password)
                                    ) {
                                        errors.password =
                                            "Password doesn’t meet the require, password should be minimum 6 characters, 1 special symbol, 1 letter.";
                                    }
                                    if (values.confirmPassword) {
                                        setConfirmPassword(
                                            values.confirmPassword
                                        );
                                    }
                                    if (!values.confirmPassword) {
                                        setConfirmPassword(
                                            values.confirmPassword
                                        );
                                        errors.confirmPassword =
                                            "Confirm password is required.";
                                    }
                                    if (
                                        values.confirmPassword !=
                                        values.password
                                    ) {
                                        errors.confirmPassword =
                                            "Passwords must match";
                                    }
                                    return errors;
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                    resetPassword(values);
                                }}
                            >
                                {(formik) => (
                                    <Form className="formikRegister">
                                        <div className="labelInputs">
                                            New Password
                                        </div>
                                        <Field
                                            className="formikInputForgoot"
                                            type={
                                                showPasword
                                                    ? "text"
                                                    : "password"
                                            }
                                            name="password"
                                            placeholder="Password"
                                        />
                                        <div
                                            className={
                                                password
                                                    ? "forgotViewIcon"
                                                    : "viewIconNone"
                                            }
                                        >
                                            <img
                                                onClick={() => {
                                                    if (showPasword) {
                                                        setShowPasword(false);
                                                    } else {
                                                        setShowPasword(true);
                                                    }
                                                }}
                                                src={
                                                    showPasword
                                                        ? view
                                                        : hidenIcon
                                                }
                                                alt="view"
                                            />
                                        </div>
                                        <ErrorMessage
                                            className="errorMessage"
                                            name="password"
                                            component="div"
                                        />
                                        <div className="labelInputs">
                                            Confirm New Password
                                        </div>
                                        <Field
                                            className="formikInputForgoot"
                                            type={
                                                showConfirmPasword
                                                    ? "text"
                                                    : "password"
                                            }
                                            name="confirmPassword"
                                            placeholder="Confirm Password"
                                        />
                                        <div
                                            className={
                                                confirmPassword
                                                    ? "forgotViewIcon"
                                                    : "viewIconNone"
                                            }
                                        >
                                            <img
                                                onClick={() => {
                                                    if (showConfirmPasword) {
                                                        setShowConfirmPasword(
                                                            false
                                                        );
                                                    } else {
                                                        setShowConfirmPasword(
                                                            true
                                                        );
                                                    }
                                                }}
                                                src={
                                                    showConfirmPasword
                                                        ? view
                                                        : hidenIcon
                                                }
                                                alt="view"
                                            />
                                        </div>
                                        <ErrorMessage
                                            className="errorMessage"
                                            name="confirmPassword"
                                            component="div"
                                        />

                                        <div className="regSubmit">
                                            <button type="submit">
                                                Reset Password
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
                <div className="marketingDivJpg ">
                    <img src={marketingJpg} alt="marketingJpg" />
                </div>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default ForgotPassword;
